import {
  getEmailUserTemplates,
  getEmailSystemTemplates,
  onUpdateEmailUserTemplates,
} from 'redux/template/sagas/emailTemplates';
import {
  getDocumentUserTemplates,
  getDocumentSystemTemplates,
  onUpdateDocumentUserTemplates,
} from 'redux/template/sagas/documentTemplates';
import {
  getSmsUserTemplates,
  getSmsSystemTemplates,
  onUpdateSmsUserTemplates,
} from 'redux/template/sagas/smsTemplates';
import { onTemplateDelete } from 'redux/template/sagas/deleteTemplate';
import { onFetchSingleTemplate } from 'redux/template/sagas/fetchSingleTemplate';
import { call, all } from 'redux-saga/effects';

export default function* formsSaga() {
  yield all([
    call(getEmailUserTemplates),
    call(getEmailSystemTemplates),
    call(onUpdateEmailUserTemplates),
    call(getDocumentUserTemplates),
    call(getDocumentSystemTemplates),
    call(onUpdateDocumentUserTemplates),
    call(getSmsUserTemplates),
    call(getSmsSystemTemplates),
    call(onUpdateSmsUserTemplates),
    call(onTemplateDelete),
    call(onFetchSingleTemplate),
  ]);
}
